import { RootState } from '../../../../stores/store';

export const deviceListSelector = (state: RootState) => state.listOfDevice;
